import { useEffect, useState } from 'react';
import Brand from '../elm-text3.png';
import { Api } from './interface';
import { bake } from './common';

const ReleaseNotes = () => {
  const [releaseNotes, setReleaseNotes] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [version, setVersion] = useState('');

  useEffect(() => {
    Api({
      sp: 'getLists',
      json: {},
    }).then((lists) => {
      let sortedHeaders = lists
        .filter((x) => x.ListType === 'releaseNote' && x.ListHeader)
        .map((x) => x.ListHeader);

      sortedHeaders = sortList(sortedHeaders);
      setHeaders([...new Set(sortedHeaders)]);
      setReleaseNotes(lists.filter((x) => x.ListType === 'releaseNote'));

      // Derive Elm version from latest release note header
      setVersion(sortedHeaders[0].split('-')[0].trim());

      bake({
        key: 'userVersion',
        value: sortedHeaders[0].split('-')[0].trim(),
      });
    });
  }, []);

  const sortList = (list) => {
    return list.sort((a, b) => {
      const aDate = new Date(a.split('-')[1].trim());
      const bDate = new Date(b.split('-')[1].trim());
      return bDate - aDate; // Sort in descending order
    });
  };

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col"></div>

          {/* Title */}
          <div className="col-8 d-flex justify-content-center align-items-center">
            <img
              width="150px"
              height="47px"
              className="img-responsive logo-text mx-2"
              src={Brand}
              alt="logo"
            />
            <div className="welcome-text">Release Notes</div>
          </div>

          {/* Current Version */}
          <div className="col">
            {version && <h4 className="text-end mt-3">Version: {version}</h4>}
          </div>
        </div>
      </div>

      {/* Version Header & Release Notes */}
      {releaseNotes && (
        <div className="d-flex justify-content-center release-note-container mt-2">
          <dl className="release-note">
            {headers.map((header, i) => (
              <figure key={i}>
                <dt>{header}</dt>
                {releaseNotes
                  .filter((x) => x.ListHeader === header)
                  .map((item, j) => (
                    <dd key={j}>{item.ListItem}</dd>
                  ))}
              </figure>
            ))}
          </dl>
        </div>
      )}
    </div>
  );
};

export default ReleaseNotes;
